import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { EntryValueLabel } from "../EntryValueLabel";

export interface BaseEntryValueProps {
    inputLabel?: string;
    className?: string;
    showLabel?: boolean;
    children?: ReactNode;
    size?: "sm" | "md" | "lg";
}

export function BaseEntryValue({
    inputLabel = "",
    className = "",
    showLabel = true,
    children,
    size = "md",
}: BaseEntryValueProps) {
    return (
        <div
            data-entry-value-root
            className={cn("py-2 w-full", size === "sm" && "py-0.5", size === "lg" && "py-3", className)}
        >
            {showLabel && inputLabel && <EntryValueLabel size={size}>{inputLabel}</EntryValueLabel>}
            <div className={cn("mt-1", size === "sm" && "mt-0.5", size === "lg" && "mt-2")}>{children}</div>
        </div>
    );
}
